<template>
  <v-row>
    <v-col sm="12" mt-3>
      <div>
        <generic-loader caption="Fetching release note data..." topMargin="2" v-if="packDataIsLoading"></generic-loader>
        <v-data-table
          :headers="headers"
          :hide-default-footer="true"
          :items="packList"
          class="elevation-0"
          data-cy="widgetMyReleaseNotesTable"
          data-test="widgetMyReleaseNotesTable"
          disable-pagination
          item-key="id"
          must-sort
          v-if="!packDataIsLoading"
        >
          <template v-slot:item="{ item }">
            <tr
              class="pointer"
              data-cy="widgetMyReleaseNotes__item"
              @click="$router.push({ name: 'dashboard', params: { packId: item.id } })"
            >
              <td data-cy="widgetMyReleaseNotes-pack">
                {{ item.title }}
              </td>
              <td data-cy="widgetMyReleaseNotes-inProcess">
                {{ getStatusCount(item, "In Process") }}
              </td>
              <td data-cy="widgetMyReleaseNotes-correctionsIndicated">
                {{ getStatusCount(item, "Corrections Indicated") }}
              </td>
              <td data-cy="widgetMyReleaseNotes-pendingPeerReview">
                {{ getStatusCount(item, "Pending Peer Review") }}
              </td>
              <td data-cy="widgetMyReleaseNotes-pendingReview">
                {{ getStatusCount(item, "Pending Review") }}
              </td>
              <td data-cy="widgetMyReleaseNotes-published">{{ getStatusCount(item, "Published") }}</td>
              <td data-cy="widgetMyReleaseNotes-packLead">{{ item.packLeadDisplayName }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import releaseNoteApi from "@/api/releaseNote";
import { mapActions, mapGetters } from "vuex";
import GenericLoader from "@/components/GenericLoader";

export default {
  components: {
    GenericLoader,
  },
  computed: {
    username() {
      return this.$store.state.session.username;
    },
    ...mapGetters({
      packList: "pack/getActivePackList",
    }),
  },
  async created() {
    try {
      this.packDataIsLoading = true;
      await this.getPackList();
    } catch (e) {
      console.error(e);
      this.$notifyError({ message: "Error fetching pack list." });
    }

    if (this.packList.length > 0) {
      try {
        this.packDataIsLoading = true;
        await this.fetchReleaseNoteData(this.packList);
      } catch (e) {
        console.error(e);
        this.$notifyError({ message: "Error fetching release notes." });
      }
    }

    this.packDataIsLoading = false;
  },
  data: () => ({
    headers: [
      {
        text: "Pack",
        value: "title",
      },
      {
        text: "In Process",
        value: "in-process",
      },
      {
        text: "Corrections Indicated",
        value: "correctionsIndicated",
      },
      {
        text: "Pending Peer Review",
        value: "pendingPeerReview",
      },
      {
        text: "Pending Review",
        value: "pendingReview",
      },
      {
        text: "Published",
        value: "published",
      },
      {
        text: "Pack Lead",
        value: "packLead",
      },
    ],
    packDataIsLoading: false,
    releaseNoteMap: {},
  }),
  methods: {
    getStatusCount(pack, documentationStatus) {
      let statusCount = [];
      if (pack.releaseNoteTotalAll === 0) {
        return 0;
      }

      const list = this.releaseNoteMap[pack.id];

      list.forEach(note => {
        if (note.documentationStatus === documentationStatus && note.qaAnalyst === this.username) {
          statusCount.push(note);
        }
      });
      return statusCount.length;
    },

    async fetchReleaseNoteData(packList) {
      const promiseList = packList.map(async pack => {
        const result = await releaseNoteApi.list(pack.id);
        this.releaseNoteMap[pack.id] = result.data.result;
      });
      try {
        await Promise.all(promiseList);
      } catch (e) {
        console.error(e);
        this.$notifyError({ message: "Error fetching release note data." });
      }
    },
    ...mapActions({
      getPackList: "pack/getList",
    }),
  },
  watch: {
    packDataIsLoading(isLoading) {
      const { getStatusCount, packList } = this;
      if (isLoading) {
        return;
      }

      const releaseNotesNeedingAttention = packList.reduce((acc, pack) => {
        return acc + getStatusCount(pack, "Corrections Indicated") + getStatusCount(pack, "Pending Peer Review");
      }, 0);

      this.$emit("releaseNotesNeedingAttentionCount", releaseNotesNeedingAttention);
    },
  },
};
</script>

<style scoped>
th {
  word-wrap: break-word !important;
}
</style>
